import { render } from "./ProductTrailer.vue?vue&type=template&id=bd56cfe4&scoped=true"
import script from "./ProductTrailer.vue?vue&type=script&lang=js"
export * from "./ProductTrailer.vue?vue&type=script&lang=js"

import "./ProductTrailer.vue?vue&type=style&index=0&id=bd56cfe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd56cfe4"]])

export default __exports__